import React, { useState, useEffect, useMemo, useRef, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import '../report.css';
import { ReactComponent as Chart } from '../../../../../POS/assets/images/svgIcons/Chart.svg';
import ApiService from '../../../../services/apiService';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import moment from 'moment';
import POSPagination from '../../pagination/pagination';
import { TfiEmail } from 'react-icons/tfi';
import { HiOutlinePrinter } from 'react-icons/hi2';
import { PiDownloadSimple } from 'react-icons/pi';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { BsFileEarmarkPdf, BsFiletypeCsv } from 'react-icons/bs';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import InvApiService from '../../../../../INVENTORY/services/apiService';

const GridView = ({}) => {
  let navigate = useNavigate();
  const [selectedFilter, setSelectedFilter] = useState('1');
  const [data, setData] = useState([]);
  const gridRef = useRef();
  const [pagination, setPagination] = useState();
  const [pageSize, setPageSize] = useState(20);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [emailModal, setEmailModal] = useState(false);
  const onOpenModal = () => setEmailModal(true);
  const onCloseModal = () => setEmailModal(false);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  const [formData, setFormData] = useState({
    itemNo: { label: 'Select ItemNo', value: 'All' },
    ItemDescription: { label: 'Select Item', value: 'All' },
    email: '',
    Category: [{ label: 'Select Category', value: 'Select Category' }],
    SubCategory: [{ label: 'Select Sub Category', value: 'Select Sub Category' }],
    StockType: [{ label: 'Select Stock Type', value: 'Select Sub Category' }],
    Warehouse: [{ label: 'Select Ware House', value: 'Select Sub Category' }],
  });
  useEffect(() => {
    getReportData();
  }, [selectedFilter]);
  const handleFilterChange = async (selectedFilter) => {
    setSelectedFilter(selectedFilter?.value);
    console.log('Selected Option:', selectedFilter);
    await getReportData();
  };
  const getReportData = async (newPageNo = pagination?.currentPage) => {
    try {
      const apiService = new ApiService();
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      params.append('GetBy', selectedFilter);
      const res = await apiService.getApiParamater('GET_TOTAL_SALE', `?${params.toString()}`);
      setData(res?.data?.result || []);
      setPagination(res.data.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };
  const ThirdFilter = [
    { value: '0', label: 'Day' },
    { value: '1', label: 'Week' },
    { value: '2', label: 'Month' },
    { value: '3', label: 'Year' },
    { value: '4', label: 'All Time' },
  ];
  const handlechart = () => {
    navigate('/admin/Reports/home');
  };
  const dateFormatter = (params) => {
    const date = moment(params.value);
    return date.isValid() ? date.format('DD-MM-YYYY') : null;
  };
  const dateComparator = (date1, date2) => {
    const momentDate1 = moment(date1);
    const momentDate2 = moment(date2);
    return momentDate1.isSame(momentDate2) ? 0 : momentDate1.isBefore(momentDate2) ? -1 : 1;
  };
  const mapPaymentType = (orderType) => {
    switch (orderType) {
      case '0':
        return 'Pending';
      case '1':
        return 'Authorized';
      case '2':
        return 'Paid';
      case '3':
        return 'Refunded';
      case '4':
        return 'Failed';
      default:
        return 'Unknown Order Type';
    }
  };
  const transformedOrders = data?.map((order) => ({
    ...order,
    orderNo: `ORD-${order.orderNo}`,
    orderAmount: Number(order.orderAmount).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }),
  }));
  const Comparison = [
    { headerName: 'Order No', field: 'orderNo', filter: true, floatingFilter: true, width: 150 },
    { headerName: 'Order Type', field: 'orderType', filter: true, floatingFilter: true, width: 200 },
    {
      headerName: 'Date',
      field: 'date',
      filter: true,
      floatingFilter: true,
      width: 180,
      filter: 'agDateColumnFilter',
      valueFormatter: dateFormatter,
      comparator: dateComparator,
    },
    { headerName: 'Cashier', field: 'cashier', filter: true, floatingFilter: true, width: 180 },
    { headerName: 'waiter', field: 'waiter', filter: true, floatingFilter: true, width: 180 },
    { headerName: 'Shift', field: 'shift', filter: true, floatingFilter: true, width: 180 },
    {
      headerName: 'Payment type',
      field: 'paymentType',
      filter: true,
      floatingFilter: true,
      width: 180,
      cellRenderer: (params) => mapPaymentType(params?.value),
    },
    { headerName: 'Customer', field: 'customer', filter: true, floatingFilter: true, width: 110 },
    { headerName: 'Branch', field: 'branch', filter: true, floatingFilter: true, width: 110 },
    { headerName: 'Amount', field: 'amount', filter: true, floatingFilter: true, width: 110 },
  ];
  const handleInputChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  const onBtnCSVExport = useCallback(() => {
    gridRef.current.api.exportDataAsCsv({
      fileName: 'TotalSaleReport.csv',
    });
  }, []);
  const onBtPDFExport = useCallback(() => {
    const doc = new jsPDF();
    const data = [];
    const columnHeaders = [];
    const comparisonFields = ['itemNo', 'itemDescription', 'category', 'subCategory', 'stockType', 'unitMeasurement', 'warehouseLocation', 'purchasePrice'];

    Comparison.forEach((col) => {
      columnHeaders.push(col.headerName);
    });

    gridRef.current.api.forEachNode((node) => {
      const row = [];
      comparisonFields.forEach((field) => {
        row.push(node.data[field]);
      });
      data.push(row);
    });

    const poppinsFont = 'data:font/ttf;base64,AAEAAAARAQAABAAw7HA...';
    doc.addFileToVFS('Poppins-Regular.ttf', poppinsFont);
    doc.addFont('Poppins-Regular.ttf', 'Poppins', 'normal');
    doc.setFont('Poppins');
    doc.setFontSize(18);
    doc.setTextColor(40, 40, 40);
    doc.text('Monthly Sale Report', 75, 12);
    doc.text('__________________________', 60, 15);
    doc.setLineWidth(2);
    doc.autoTable({
      head: [columnHeaders],
      body: data,
      styles: {
        fontSize: 6,
      },
      headStyles: {
        fillColor: [209, 126, 6],
        textColor: [255, 255, 255],
        fontSize: 6,
      },
      columnStyles: {
        0: { cellWidth: 19 },
        1: { cellWidth: 19 },
        2: { cellWidth: 19 },
        3: { cellWidth: 19 },
        4: { cellWidth: 19 },
        5: { cellWidth: 19 },
        6: { cellWidth: 19 },
        7: { cellWidth: 19 },
        8: { cellWidth: 15 },
        9: { cellWidth: 15 },
        10: { cellWidth: 15 },
      },
      startY: 20,
      theme: 'striped',
    });
    doc.save('Total-Sale-Report.pdf');
  }, []);
  const handleClearFilters = () => {
    getReportData();
  };
  const SendEmail = async () => {
    try {
      if (!formData.email) {
        toast.warning('Enter User Email to send Report');
        return;
      }
      const requestBody = {
        // toEmail: "shahzaibawan864@gmail.com",
        toEmail: formData.email,
        subject: 'Monthly Sale Report',
        body: `
                <div className='printhead2 mb-5 px-4'>
                    <table>
                        <thead className='dynoTable' style='background-color: #6E5199; color: #fff;'>
                            <tr>
                                <th>Order No</th>
                                <th>Order Type</th>
                                <th>Date</th>
                                <th>Cashier</th>
                                <th>waiter</th>
                                <th>Shift</th>
                                <th>Payment type</th>
                                <th>Customer</th>
                                <th>Branch</th>
                                <th>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            ${data
                              ?.map(
                                (row, index) => `
                                <tr key=${index}>
                                    <td className='m-0 p-0'><input style='width: 100px;' className='p-2' type='text' value='${row.orderNo}' disabled /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.orderType}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.date}' /></td>
                                    <td className='m-0 p-0'><input style='width: 140px;' className='p-2' disabled value='${row.cashier}' /></td>
                                    <td className='m-0 p-0'><input style='width: 80px;' className='p-2' disabled value='${row.waiter}' /></td>
                                    <td className='m-0 p-0'><input style='width: 150px;' className='p-2' disabled value='${row.shift}' /></td>
                                    <td className='m-0 p-0'><input style='width: 120px;' className='p-2' disabled value='${row.paymentType}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' disabled value='${row.customer}' /></td>
                                    <td className='m-0 p-0'><input style='width: 110px;' className='p-2' type='text' value='${row.branch}' disabled /></td>
                                    <td className='m-0 p-0'><input className='p-2 w-100' type='text' value='${row.amount?.toFixed(2)}' disabled /></td>
                                </tr>
                            `
                              )
                              .join('')}
                        </tbody>
                    </table>
                </div>`,
      };
      const invapiService = new InvApiService();
      const response = await invapiService.post('SEND_EMAIL', requestBody);
      if (response.status === 200) {
        onCloseModal();
        toast.success('Email send successfully');
        handleClearFilters();
      }
    } catch (error) {
      console.error('Error:', error);
    }
  };
  return (
    <div className="pt-5">
      <div className="d-flex justify-content-between p-2 gridBg mt-2" style={{ borderRadius: '8px 8px 0px 0px ' }}>
        {/* <div className='viebtn' onClick={() => handlechart()}><Chart /></div> */}
        <div className="d-flex  p-0">
          <nav className="nav nav-pills weekfilter ">
            {ThirdFilter?.map((filter) => (
              <button
                key={filter.value}
                className={`nav-link ${selectedFilter === filter.value ? 'activecls' : ''}`}
                onClick={() => handleFilterChange(filter)}
              >
                {filter.label}
              </button>
            ))}
          </nav>
        </div>
        <div className="d-flex gap-3 ">
          <div className="mainbtnGry flex-end gap-2">
            <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
              <DropdownToggle tag="span" data-toggle="dropdown" aria-expanded={dropdownOpen}>
                <PiDownloadSimple size={25} />
              </DropdownToggle>
              <DropdownMenu className="mt-3">
                <DropdownItem onClick={onBtnCSVExport} className="gap-3 d-flex center">
                  <BsFiletypeCsv />
                  <div>Export CSV</div>
                </DropdownItem>
                {/* <DropdownItem onClick={onBtExcelExport} className='gap-3 d-flex center'><LiaFileExcel/><div>Export Excel</div></DropdownItem> */}
                <DropdownItem onClick={onBtPDFExport} className="gap-3 d-flex center">
                  <BsFileEarmarkPdf />
                  <div>Export PDF</div>
                </DropdownItem>
              </DropdownMenu>
            </Dropdown>
          </div>
          <div className="mainbtnRed flex-end ">
            <HiOutlinePrinter size={25} />
          </div>
          <div className="mainbtn flex-end gap-1" onClick={onOpenModal}>
            <div className="center">
              <TfiEmail size={25} />
            </div>
            <Modal size="md" show={emailModal} onHide={onCloseModal} contentLabel="Email Modal" style={customStyles}>
              <Modal.Header closeButton>
                <Modal.Title className="center">Send Email</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <input
                    type="email"
                    className="form-Input w-100"
                    id="validationCustom02"
                    value={formData.email}
                    name="email"
                    onChange={handleInputChange}
                    placeholder="Enter Email"
                  />
                </div>
              </Modal.Body>
              <Modal.Footer className="end p-3">
                <button className="mainbtnGry" onClick={onCloseModal}>
                  Close
                </button>
                <button className="mainbtnRed" onClick={SendEmail}>
                  Save
                </button>
              </Modal.Footer>
            </Modal>
          </div>
        </div>
      </div>
      <div className="POsgridshad">
        <div className="ag-theme-quartz" style={{ height: 600 }}>
          <AgGridReact
            rowData={transformedOrders}
            columnDefs={Comparison}
            ref={gridRef}
            getRowStyle={(params) => {
              if (params.node.rowIndex % 2 === 0) {
                return { background: '#F0EDF5' };
              } else {
                return { background: '#fff' };
              }
            }}
          />
        </div>
        <POSPagination setPageSize={setPageSize} pagination={pagination} getItems={getReportData} />
      </div>
    </div>
  );
};

const mapStatetoProps = (state) => state;
export default connect(mapStatetoProps)(GridView);
const customStyles = {
  content: {
    width: '30%',
    height: '75%',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
};
